import { FromSchema } from '@40seas/entities/common';
import { Address, AddressSchema, Identification, IdentificationSchema } from '@40seas/models';
import { z } from 'zod';
import { CreditReviewBankAccount, CreditReviewBankAccountSchema } from './credi-review.bank-account-activity.bank-account';
import {
    CreditReviewBankAccountActivityReport,
    CreditReviewBankAccountActivityReportSchema,
} from './credit-review-bank-account-activity.report';

export const CreditReviewBankAccountActivitySchema = z
    .object({
        bankAccounts: z.array(CreditReviewBankAccountSchema),
        reports: CreditReviewBankAccountActivityReportSchema,
    })
    .strict();

export class CreditReviewBankAccountActivity extends FromSchema(CreditReviewBankAccountActivitySchema) {
    bankAccounts: CreditReviewBankAccount[];
    reports: CreditReviewBankAccountActivityReport;
}
